import { useQuery } from "@tanstack/react-query";
import { WiMuleSQL } from "../../services/WiMuleSQL";

export const useGetOrdersByDateRange = (fromDateTime, toDateTime, options = {}) => {
  const {asset, resource} = options;
  // Helper function to ensure the fromDate starts at 00:00:01
  const formatFromDate = (date) => {
    date.setHours(0, 0, 0); // Use 00:00:00 instead of 00:00:01
    return date.toISOString().split(".")[0];
  };

  // Helper function to ensure the toDate ends at 23:59:59
  const formatToDate = (date) => {
    date.setHours(23, 59, 59);
    return date.toISOString().split(".")[0];
  };

  const formatDate = (inputDate) => {
    const date = new Date(inputDate); // Clone the input date
    return date.toISOString().split("T")[0]; // Extract only the date portion (YYYY-MM-DD)
  };


  const fetchData = async () => {
    const params = new URLSearchParams({
      fromDate: formatDate(fromDateTime),
      toDate: formatDate(toDateTime),
    });

    if (asset) {
      params.append("asset", asset);
    }

    if (resource) {
      params.append("resource", resource);
    }

    const queryString = `${WiMuleSQL}/api/WiTool/GetServerOrders?${params.toString()}`;

    const response = await fetch(queryString, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (response.status === 204) {
      return {success: true,
        data: [],
      }
    }

    if (!response.ok) {
      throw new Error(`HTTP Error: ${response.status}`);
    }

    return response.json();
  };

  const { data, isLoading, isError, error } = useQuery({
    queryKey: [
      "getOrdersByDateRange",
      fromDateTime,
      toDateTime,
      asset ?? null,
      resource ?? null,
    ],
    queryFn: fetchData,
    enabled: !!fromDateTime && !!toDateTime,
    refetchInterval: () =>
      document.visibilityState === "visible" ? 60000 : 600000,
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: true,
  });


  return { data, isLoading, isError, error };
};
